var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxoutlinesearchEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4,21.7c-5.6,0-10.2-4.6-10.2-10.2S5.8,1.3,11.4,1.3s10.2,4.6,10.2,10.2S17,21.7,11.4,21.7z M11.4,2.8 c-4.8,0-8.7,3.9-8.7,8.7s3.9,8.7,8.7,8.7s8.7-3.9,8.7-8.7S16.2,2.8,11.4,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,22.5l-2-2c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0l2,2c0.3,0.3,0.3,0.8,0,1.1c-0.1,0.1-0.3,0.2-0.5,0.2C21.8,22.7,21.7,22.7,21.5,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,14.7c-0.3,0-0.4-0.2-0.5-0.4l0,0c0,0-1.3-2.1-3.5-2c-0.4,0-0.8-0.3-0.8-0.7s0.3-0.8,0.7-0.8 c3-0.1,4.7,2.6,4.8,2.8c0.2,0.4,0.1,0.7-0.3,1C16,14.7,15.8,14.7,15.7,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,17.6L11.4,17.6c-2.1-0.1-6.1-1.5-6.1-6c0-0.1-0.1-2.7,1.7-4.4C8,6,9.5,5.4,11.4,5.4 c0.4,0,0.8,0.3,0.8,0.8S11.9,7,11.4,7C9.9,6.9,8.8,7.3,8,8.1c-1.3,1.3-1.3,3.4-1.3,3.4c0,4.2,4.5,4.5,4.7,4.5 c0.4,0,0.7,0.4,0.7,0.8C12.1,17.3,11.8,17.6,11.4,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,17.1c-0.3,0-0.6-0.2-0.7-0.6c0-0.1-0.4-1.6-1.9-1.6c-0.1,0-1.5,0-2.5-1C8.3,13.4,8,12.5,8,11.5 C8,11.4,8,10,9,9c0.6-0.6,1.4-0.9,2.5-0.9c0.4,0,0.8,0.3,0.8,0.8S12,9.7,11.5,9.7c-0.6,0-1.1,0.2-1.4,0.5 c-0.5,0.6-0.6,1.4-0.6,1.4c0,0.6,0.2,1,0.5,1.3c0.5,0.5,1.4,0.6,1.5,0.6l0,0c2.1,0,3.1,1.8,3.3,2.7c0.1,0.4-0.1,0.8-0.5,0.9 C14.1,17.1,14,17.1,14,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12.1c-0.2,0-0.4-0.1-0.6-0.3c-1.1-1.4-2.9-2-3-2C13,9.7,12.8,9.3,12.9,9c0.1-0.4,0.5-0.6,0.9-0.5 c0.1,0,2.3,0.7,3.7,2.5c0.3,0.3,0.2,0.8-0.1,1C17.2,12.1,17.1,12.1,17,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,8.4c-0.1,0-0.3,0-0.4-0.1c-1.2-0.8-2.4-1-2.4-1c-0.4-0.1-0.7-0.5-0.6-0.9c0.1-0.4,0.5-0.7,0.9-0.6 c0.1,0,1.4,0.3,2.9,1.3c0.3,0.2,0.4,0.7,0.2,1C16.9,8.3,16.6,8.4,16.4,8.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinesearchEvidence);
export default __webpack_public_path__ + "static/media/vuesaxoutlinesearch-evidence.38630d106c044242a6b5f21ee29c5208.svg";
export { ForwardRef as ReactComponent };